<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="tab-panel-content-wrapper">

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Shared Offer Sets
        <i class="pi pi-info-circle"
          pTooltip="When enabled, this account becomes eligible to receive shared offer sets. When disabled, the account will not receive shared offer sets—even if all other conditions are met."
        tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="sharedOfferSetsEnabled"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Refresh Offer Sets with Inventory Data
        <i class="pi pi-info-circle"
          pTooltip="When enabled, the account’s MPOP Offer Sets will be automatically updated to reflect changes in the inventory feed (excludes pricing data—see Auto Price Update setting)."
        tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="accountOfferSetRefresh"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Custom Title Display Override
        <i class="pi pi-info-circle"
          pTooltip="Use this setting to override the Offer Set title to map in additional inventory info when OEM compliance requires it. If left blank, the title will default to the standard format (condition/year/make/model/trim)."
        tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="customTitleDisplayOverride"></p-toggleswitch>
    </div>

    @if (this.form.get('customTitleDisplayOverride').value) {
      <div>
        <div class="custom-title-indent" style="padding-left: 30px;">
          <div class="tab-panel-input-wrapper final-url-dropdown">
            <label class="field-input-label tab-input-label">New Offer Set Custom Title Override Text</label>
            <input pInputText class="input-text-wrapper" type="text" formControlName="newOfferSetCustomTitleOverrideText">
          </div>
          <div class="tab-panel-input-wrapper final-url-dropdown">
            <label class="field-input-label tab-input-label">Used Offer Set Custom Title Override Text</label>
            <input pInputText class="input-text-wrapper" type="text" formControlName="usedOfferSetCustomTitleOverrideText">
          </div>
          <div class="tab-panel-input-wrapper final-url-dropdown">
            <label class="field-input-label tab-input-label">CPO Offer Set Custom Title Override Text</label>
            <input pInputText class="input-text-wrapper" type="text" formControlName="cpoOfferSetCustomTitleOverrideText">
          </div>
        </div>
      </div>
    }

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Minimize Disclaimer
        <i class="pi pi-info-circle"
          pTooltip="When enabled, disclosures will be collapsed by default. When disabled, disclosures will be fully expanded by default."
        tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="minimizeDisclaimer"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        New Main CTA Text
        <i class="pi pi-info-circle"
          pTooltip="Changes the main call-to-action text on New Offer Sets."
        tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="newMainCtaText">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Used Main CTA Text
        <i class="pi pi-info-circle"
          pTooltip="Changes the main call-to-action text on Used Offer Sets."
        tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="usedMainCtaText">
    </div>

    @if (!showDisclosuresTab) {
      <div class="tab-panel-input-wrapper final-url-dropdown">
        <label class="field-input-label tab-input-label">
          Enhanced Disclosure
          <i class="pi pi-info-circle"
             pTooltip="Enables Enhanced Disclosures to be applied directly to MPOP Offer Sets, independent of Dynamic Creative."
             tooltipPosition="top"></i>
        </label>
        <p-toggleswitch formControlName="enhancedDisclosure"></p-toggleswitch>
      </div>
      <div class="tab-panel-input-wrapper final-url-dropdown">
        <label class="field-input-label tab-input-label">
          Disclosure Set
          <i class="pi pi-info-circle"
             pTooltip="Select from pre-formatted disclosure templates designed to meet OEM and compliance requirements."
             tooltipPosition="top"></i>
        </label>
        <p-select
          [options]="disclosureSetOptions"
          formControlName="disclosureSet"
          optionLabel="label"
          optionValue="value"
          [pTooltip]="disclosureSetTooltip"
          tooltipPosition="top"></p-select>
      </div>
    }
  </div>
</form>

